// extracted by mini-css-extract-plugin
module.exports = {"container":"Company_container__FbS9E","qtd":"Company_qtd__oJNwG","qtd1":"Company_qtd1__Rdzqd","qtdSuave":"Company_qtdSuave__QgbCR"};